module.exports = __webpack_public_path__ + "img/jtzl.830dd8f8.png";